import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { IFieldSpecs } from 'libraries/module/formbuilder/fields/interfaces/field-specs';
import { ILabels } from 'libraries/interfaces/ILabels';
import { Yii } from 'libraries/interfaces/Yii';
import { ICoordsTable } from "libraries/service/table-keyboard-navigation/table-keyboard-navigation.service";

@Component({
    selector: 'block-title',
    template: `
        <ng-template #template>
            <td mat-cell
                class="block-data block-title"
                [class.empty-cell]="isEmpty"
                [class.block-title-trip]="isTripBlock"
                [class.trip-and-not-land]="isTripBlock && !isTripLandQuoteBlock"
                [class.land-quote]="isTripLandQuoteBlock">
                <div class="title-container" *ngIf="!isEmpty || fieldConfig?.disabled">
                    <div class="category-icon-container" *ngIf="icon">
                        <fa-icon [icon]="icon | iconNameToDefinition"></fa-icon>
                    </div>
                    <div class="title" [matTooltip]="title">
                        <ng-container *ngIf="!isEmpty">{{title}}</ng-container>
                        <em *ngIf="isEmpty">{{labels.noTitle}}</em>
                    </div>
                </div>
                <block-title-editor *ngIf="isEmpty && !fieldConfig?.disabled"
                                    [fieldConfig]="fieldConfig"
                                    (onFocusField)="onFocusField.emit($event)">
                </block-title-editor>
            </td>
        </ng-template>
    `,
    styles: [`
        :host {
            display: none
        }

        td.block-data.block-title {
            position: sticky;
            left: 60px;
            z-index: 1;
            width: 60px;
            min-width: 60px;
            padding: .75rem;
        }

        td.block-data.block-title.empty-cell {
            padding: 0;
        }

        td.block-data.block-title.block-title-trip.trip-and-not-land {
            /*border-right: 0 solid transparent;*/
        }

        .title-container {
            display: flex;
        }

        .label {
            position: absolute;
            font-size: .75rem;
            top: .05rem;
            left: .1rem;
            opacity: 0.5;
        }

        .category-icon-container {
            width: 32px;
            margin-right: .75rem;
            text-align: center;
        }

        .title {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            width: 220px;
        }

        em {
            color: rgba(0, 0, 0, 0.38);
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class BlockTitleComponent implements OnInit {

    @Input()
    public colspan: number = 1;

    @Input()
    public isTripBlock: boolean;

    /**
     * Indicate that Edition is opened from keyboard navigation  in parent component
     */
    @Input()
    public isKeyboardOpen: boolean;

    @Input()
    public isTripLandQuoteBlock: boolean;

    @Input()
    public isEmpty: boolean;

    @Input()
    public fieldConfig: IFieldSpecs;

    @Input()
    public icon: string;

    @Input()
    public title: string;

    @Input()
    public label: string;

    @Output()
    public readonly onFocusField: EventEmitter<ICoordsTable> = new EventEmitter<ICoordsTable>();

    public labels: ILabels = {
        noTitle: Yii.t("wui-quotation-js", "Sans titre")
    };

    @ViewChild('template', {read: TemplateRef, static: true})
    private readonly template: TemplateRef<{}>;

    constructor(
        private readonly viewContainerRef: ViewContainerRef
    ) {
    }

    public ngOnInit(): void {
        this.viewContainerRef.createEmbeddedView(this.template);
    }
}
